// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { operatorId } from './Operator';
import { fermentationScheduledActionId } from './FermentationScheduledAction';
import { fermentationTimepointId } from './FermentationTimepoint';
import { z } from 'zod';
export const fermentationBrothId = (z.number());
export const fermentationBroth = z.object({
    id: fermentationBrothId,
    fermentation_id: fermentationId,
    date_time: z.date(),
    container_tare_g: z.string().nullable(),
    container_gross_g: z.string().nullable(),
    sample_wet_g: z.string().nullable(),
    sample_dry_g: z.string().nullable(),
    notes: z.string().nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    scheduled_action_id: fermentationScheduledActionId.nullable(),
    timepoint_id: fermentationTimepointId.nullable(),
    auto_created_at_end_of_run: z.boolean(),
    ended_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    disposed_at: z.date().nullable(),
    disposed_by: operatorId.nullable(),
    disposal_note: z.string().nullable(),
});
export const fermentationBrothInitializer = z.object({
    id: fermentationBrothId.optional(),
    fermentation_id: fermentationId,
    date_time: z.date().optional(),
    container_tare_g: z.string().optional().nullable(),
    container_gross_g: z.string().optional().nullable(),
    sample_wet_g: z.string().optional().nullable(),
    sample_dry_g: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    scheduled_action_id: fermentationScheduledActionId.optional().nullable(),
    timepoint_id: fermentationTimepointId.optional().nullable(),
    auto_created_at_end_of_run: z.boolean().optional(),
    ended_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    disposed_at: z.date().optional().nullable(),
    disposed_by: operatorId.optional().nullable(),
    disposal_note: z.string().optional().nullable(),
});
export const fermentationBrothMutator = z.object({
    id: fermentationBrothId.optional(),
    fermentation_id: fermentationId.optional(),
    date_time: z.date().optional(),
    container_tare_g: z.string().optional().nullable(),
    container_gross_g: z.string().optional().nullable(),
    sample_wet_g: z.string().optional().nullable(),
    sample_dry_g: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    scheduled_action_id: fermentationScheduledActionId.optional().nullable(),
    timepoint_id: fermentationTimepointId.optional().nullable(),
    auto_created_at_end_of_run: z.boolean().optional(),
    ended_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    disposed_at: z.date().optional().nullable(),
    disposed_by: operatorId.optional().nullable(),
    disposal_note: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationBroth.js.map